/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import {Navigate, useLocation} from "react-router-dom";

const AuthorizedRoute = ({
                           component: Component,
                           isLoggedUser,
                           backUrl,
                         }) => {
  const location = useLocation();
  let currentBackUrl = backUrl == null ? location?.pathname : backUrl;

  if (location?.search) {
    currentBackUrl += location.search;
  }

  if (location?.hash) {
    currentBackUrl += location.hash;
  }

  if (isLoggedUser) {
    return <Component />
  }

  return (
    <Navigate
      to={`/login?BackUrl=${encodeURIComponent(currentBackUrl)}`}
      state={location.state}
      replace
    />
  );
}

export default AuthorizedRoute;
